/**
 * 界面侧的漏斗埋点。
 *
 * 为什么需要：服务端只看得见「打开插件」和「真的打印了」两端。实测 326 个
 * 打开过的用户里有 272 个从没打印过（83%），但中间是黑箱 —— 不知道他们是
 * 没建出模板、没选到记录，还是预览出来不对就走了。这几个点补上中间段。
 *
 * 三条约束：
 *   1. 每个步骤一次会话只报一次（内存去重），服务端再按小时节流一次。
 *      KV 免费版每天只有 1000 次写，不能让埋点把配额吃光。
 *   2. 完全 fire-and-forget：失败静默，绝不 await 在主流程里。
 *   3. 不带任何业务内容，只有账号 id 和步骤名。
 */
import { getBaseUserId } from '../api/bitable';

const API_BASE = 'https://printpro.xiaomiao.win';

export type FunnelStep =
  | 'tpl_create'
  | 'tpl_edit'
  | 'record'
  | 'preview'
  | 'ai_open'
  | 'ai_key'
  | 'ai_done'
  | 'excel_import'
  | 'attach_ok'
  | 'attach_fail';

const sent = new Set<FunnelStep>();
let accountIdPromise: Promise<string> | null = null;

export function track(step: FunnelStep): void {
  if (sent.has(step)) return;
  sent.add(step);
  void (async () => {
    try {
      // 独立标签页（全屏编辑器）没有 SDK，账号在页面地址里；不兜这一下，
      // 改版后编辑动作全发生在那边，tpl_edit 就成了漏斗里的黑洞
      if (!accountIdPromise) {
        const fromUrl = new URLSearchParams(window.location.search).get('account');
        accountIdPromise = fromUrl ? Promise.resolve(fromUrl) : getBaseUserId();
      }
      const accountId = await accountIdPromise;
      if (!accountId) return;
      await fetch(`${API_BASE}/api/step`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ accountId, step }),
        keepalive: true,
      });
    } catch {
      /* 埋点失败不影响任何功能 */
    }
  })();
}
